
import { defineComponent } from 'vue'
export default defineComponent({
    name: 'contex-broker-card',
    data() {
        return {
            myData: {}
        }
    },
    props: {
        data: {
            type: Object
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        loadData() {
            this.myData = this.data as any
        }
    }
})
